// Import necessary modules if needed
import * as Formatting from './Formatting';

// Function to create cleaned member data
export function CleanedData() {
  const customAgeGroups = [
    [-Infinity, 17, "Unknown"],
    [18, 24, "18-24"],
    [25, 34, "25-34"],
    [35, 49, "35-49"],
    [50, 64, "50-64"],
    [65, Infinity, "65+"],
  ];

  const customTenureGroups = [
    [-Infinity, 1, "<1"],
    [1, 5, "1-5"],
    [6, 10, "6-10"],
    [11, 15, "11-15"],
    [16, 20, "16-20"],
    [21, Infinity, "21+"],
  ];

  const PartisanGroups = [
    [-Infinity, 24, "Probable Republican"],
    [25, 45, "Likely Republican"],
    [46, 55, "Uncertain"],
    [56, 75, "Likely Democrat"],
    [76, Infinity, "Probable Democrat"]
  ];

  const VoterGroups = [
    [-Infinity, 20, "Very Unlikely to Vote"],
    [21, 40, "Unlikely to Vote"],
    [41, 60, "Neutral"],
    [61, 80, "Likely to Vote"],
    [81, Infinity, "Very Likely to Vote"]
  ];

  const TurnoutGroups = [
    [-Infinity, 20, "Very Unlikely to Turn Out"],
    [21, 40, "Unlikely to Turn Out"],
    [41, 60, "Neutral"],
    [61, 80, "Likely to Turn Out"],
    [81, Infinity, "Very Likely to Turn Out"]
  ];

  const raceMapping = {
    "H": "Hispanic",
    "W": "Caucasian",
    "B": "African-American",
    "A": "Asian",
    "U": "Other",
    "N": "Native American",
    "O": "Other",
    "unknown": "Other", 
    "Uncoded": "Other"
  };

  const customRPACGroups = [
    [-Infinity, 99, "<100"],
    [100, 300, "100-250"],
    [251, 400, "251-400"],
    [401, 550, "401-550"],
    [551, 700, "551-700"],
    [701, 850, "701-850"],
    [851, 1000, "851-1000"],
    [1001, Infinity, "1000+"],
  ];
  
  const MemberDatabase = [
    ["ASSOC", "ASSOC", "string", Formatting.formatAssociationName], 
    ["GenderFromFile", "GENDER", "string", Formatting.formatAssociationName], 
    ["RaceFromFile", "RACE", "string", Formatting.formatAssociationName], 
    ];



  const allDataCleaning = [].concat(MemberDatabase);


  return allDataCleaning;
}



